import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {
  Ech0134GrundbuchmeldungSearchRequest,
  Ech0134grundbuchmeldungService,
  EchGrundbuchmeldungListEntry
} from '../../core/grundbuchmeldung-api';
import { Observable } from 'rxjs';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import { Ech0134ModuleStateData } from '../ech0134-module-state-data';
import { ListLoaderPaginationBuilder } from '../../shared/components/list-loader/list-loader-pagination';
import { first, map } from 'rxjs/operators';
import { PaginationLookupResult } from '../../shared/components/list-loader/pagination-lookup-result';
import { Injectable } from '@angular/core';
import { CapAlertService } from '../../core/extension/exceptions/cap-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { RouteHistoryService } from '../../core/services/route-history.service';
import { LoadingState } from '../../shared/components/list-loader/loading-state';
import GrundbuchmeldungSortEnum = Ech0134GrundbuchmeldungSearchRequest.GrundbuchmeldungSortEnum;
import SortDirectionEnum = Ech0134GrundbuchmeldungSearchRequest.SortDirectionEnum;

@Injectable()
export class GrundbuchmeldungListResolver {
  constructor(
    private moduleStateData: Ech0134ModuleStateData,
    private backend: Ech0134grundbuchmeldungService,
    private capAlertService: CapAlertService,
    private translate: TranslateService,
    private router: Router,
    private routeHistory: RouteHistoryService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<ListLoader<EchGrundbuchmeldungListEntry>>
    | Promise<ListLoader<EchGrundbuchmeldungListEntry>>
    | ListLoader<EchGrundbuchmeldungListEntry> {
    const searchRequest = <Ech0134GrundbuchmeldungSearchRequest>(JSON.parse(route.queryParams.request) || {
      tagebuchNummer: {}
    });
    this.moduleStateData.lastMeldungSearchRequest = searchRequest;
    const listLoader = ListLoaderPaginationBuilder.builder<EchGrundbuchmeldungListEntry>()
      .setNoSortModel(true)
      .setCurrentPage(1)
      .setPageSize(15)
      .setLookupItemFunc((offset, limit, sortColumn) => {
        searchRequest.offset = offset;
        searchRequest.limit = limit;
        searchRequest.grundbuchmeldungSort = sortColumn ? sortColumn.sortEnumBackend : GrundbuchmeldungSortEnum.GESCHAEFTS_NUMMER;
        searchRequest.sortDirection = sortColumn ? sortColumn.sortDirectionBackend : SortDirectionEnum.ASC;
        return this.backend.searchMeldung(searchRequest).pipe(
          map((response) => {
            if (response.totalItems === 0) {
              this.capAlertService.info(this.translate.instant('KeineResultateGefunden'), undefined, false);
              this.router.navigate([this.routeHistory.previousRoute]);
            }
            return <PaginationLookupResult<EchGrundbuchmeldungListEntry>>{
              result: response.results,
              totalItems: response.totalItems
            };
          })
        );
      })
      .build();
    return new Promise((resolve1) => {
      listLoader.state$.pipe(first((state1) => state1 === LoadingState.ALL_DATA_LOADED)).subscribe(() => {
        resolve1(listLoader);
      });
    });
  }
}
